import React, { useRef } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const HeroSlider = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slides = [
    {
      backgroundImage: "/assets/image/IMG-20250429-WA0013.jpg",
      overlayImage: "/assets/img/update1/hero/hero_overlay_7.png",
      title: "Cleaning",
      title_bg: "Experts",
      subtitle: "Home Cleaning",
      description:
        "Delivering deep, reliable, and eco-friendly cleaning across Dubai with a focus on hygiene, safety, and customer satisfaction.",
    },
    {
      backgroundImage: "/assets/image/IMG-20250429-WA0005.jpg",
      overlayImage: "/assets/img/update1/hero/hero_overlay_7.png",
      title: "Pest",
      title_bg: "Control",
      subtitle: "Safe Solutions",
      description:
        "Trusted pest control services that eliminate threats and prevent future infestations — safe for families, pets, and the planet.",
    },
    {
      backgroundImage: "/assets/image/IMG-20250429-WA0007.jpg",
      overlayImage: "/assets/img/update1/hero/hero_overlay_7.png",
      title: "Dubai",
      title_bg: "Service",
      subtitle: "24/7 Support",
      description:
        "Round-the-clock support from a seasoned team that’s committed to keeping your spaces clean, safe, and pest-free.",
    },
  ];

  return (
    <div className="th-hero-wrapper hero-slider-13 th-carousel" id="hero">
      <Wrapper>
        <Slider ref={sliderRef} {...settings} className="hero-slider-13">
          {slides.map((slide, index) => (
            <div key={index} className="th-hero-slide">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage: `url(${slide.backgroundImage})`,
                }}
              >
                <img
                  src={slide.overlayImage}
                  alt={`Hero Imagee ${index + 1}`}
                />
              </div>

              <div className="container">
                <div className="hero-style13">
                  {slide.title && (
                    <h1
                      className="hero-title text-white"
                      data-ani="slideindown"
                      data-ani-delay="0.4s"
                    >
                      {slide.title}{" "}
                      <span className="bg-theme">{slide.title_bg}</span>
                    </h1>
                  )}

                  {slide.subtitle && (
                    <h1
                      className="hero-title text-white"
                      data-ani="slideindown"
                      data-ani-delay="0.1s"
                    >
                      {slide.subtitle}
                    </h1>
                  )}

                  <p
                    className="hero-text text-white"
                    data-ani="slideinup"
                    data-ani-delay="0.1s"
                  >
                    {slide.description}
                  </p>

                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.5s"
                  >
                    <Link to="/service" className="th-btn style3">
                      Our Services{" "}
                      <i className="fas fa-long-arrow-right ms-2"></i>
                    </Link>

                    <Link to="/contact" className="th-btn style2">
                      CONTACT US{" "}
                      <i className="fas fa-long-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Wrapper>
    </div>
  );
};

const Wrapper = styled.section`
  position: relative;

  .th-hero-slide {
    position: relative;
    display: flex;
    align-items: center;
  }

  .th-hero-bg {
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;
  }

  .th-hero-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  .hero-text {
    text-align: justify;
  }

  @media screen and (max-width: 1024px) {
    .hero-style13 {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .hero-style13 .hero-meta {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .hero-style13 .hero-text {
      max-width: 700px;
      margin: 20px auto;
    }

    .hero-style13 .btn-group {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 375px) {
    .textt {
      font-size: 16px !important;
    }

    .hero-style13 .hero-text {
      font-size: 14px !important;
    }
  }
`;

export default HeroSlider;
